import styled, { css } from 'styled-components';

const ButtonStyled = styled.button.attrs({
  className: 'button',
})`
  ${props => {
    const { theme = {}, darkMode = false, activeBgColor = undefined } = props;
    const { colors = {}, fonts = {}, media = {} } = theme;
    return css`
      border: 2px solid #000;
      z-index: 1;
      background: ${activeBgColor ? activeBgColor : 'none'};
      padding: 10px;
      margin: 4px;
      position: relative;

      &:after {
        position: absolute;
        content: "";
        width: 100%;
        height: 0;
        bottom: 0;
        left: 0;
        z-index: -1;
        background: ${activeBgColor ? activeBgColor : '#000'};
        transition: all 0.3s ease;
      }

      &:hover {
        color: #fff;
      }

      &:hover:after {
        top: 0;
        height: 100%;
      }

      &:active {
        top: 2px;
      }
    `;
  }}
`;

export default ButtonStyled;
